import { render, staticRenderFns } from "./ExaminationDetails.vue?vue&type=template&id=7d9c74ce"
import script from "./ExaminationDetails.vue?vue&type=script&lang=js"
export * from "./ExaminationDetails.vue?vue&type=script&lang=js"
import style0 from "./ExaminationDetails.vue?vue&type=style&index=0&id=7d9c74ce&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports